import { createContext, useContext, useEffect, useState } from 'react'
import { getCurrentPosition } from '../../utils/geolocation'

const GeolocationContext = createContext()
export const useGeolocationContext = () => useContext(GeolocationContext)

export const GeolocationProvider = ({ children }) => {
  const [permissionGranted, setPermissionGranted] = useState(null)
  const [coords, setCoords] = useState(null)

  useEffect(() => {
    const checkPermission = async () => {
      // 🚫 iOS Safari gak support Permissions API
      if (!navigator.permissions) {
        console.warn('Permissions API tidak disupport, fallback manual check...')
        try {
          // langsung coba getCurrentPosition, kalau gagal berarti denied
          const pos = await getCurrentPosition({ timeout: 5000 })
          setCoords(pos)
          setPermissionGranted(true)
        } catch (err) {
          console.warn('Gagal ambil lokasi via fallback:', err)
          setPermissionGranted(false)
        }
        return
      }

      try {
        const result = await navigator.permissions.query({ name: 'geolocation' })

        if (result.state === 'granted') setPermissionGranted(true)
        else if (result.state === 'denied') setPermissionGranted(false)
        else setPermissionGranted(null)

        // Listen perubahan izin secara real-time
        result.onchange = () => {
          if (result.state === 'granted') setPermissionGranted(true)
          else if (result.state === 'denied') setPermissionGranted(false)
          else setPermissionGranted(null)
        }
      } catch (err) {
        console.error('Gagal ngecek permission geolocation:', err)
        setPermissionGranted(false)
      }
    }

    checkPermission()
  }, [])

  const requestLocation = async () => {
    try {
      const pos = await getCurrentPosition({ timeout: 7000 })
      setCoords(pos)
      setPermissionGranted(true)
    } catch (err) {
      console.error('Permission geolocation denied:', err)
      setPermissionGranted(false)
    }
  }

  return (
    <GeolocationContext.Provider
      value={{
        permissionGranted,
        coords,
        requestLocation,
        setPermissionGranted,
      }}
    >
      {children}
    </GeolocationContext.Provider>
  )
}
